// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as FlightsCurrentActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import { push } from 'react-router-redux';
import FlightsCurrent from '../components/FlightCurrent/FlightsCurrent';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingActive: state.flights.isFetchingActive,
    activeFlights: state.flights.activeFlights,
    fetchActiveError: state.flights.fetchActiveError,
    isDeleting: state.flights.isDeleting,
    successDelete: state.flights.successDelete,
    deleteActiveError: state.flights.deleteActiveError,
    locale: state.locale.locale,
    localValues: state.localValues,
    fetchError: state.editFlight.fetchError,
    putError: state.editFlight.putError,
    successUpdate: state.editFlight.successUpdate,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...FlightsCurrentActions,
    ...AlertActions,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightsCurrent);



// WEBPACK FOOTER //
// ./src/modules/flights/containers/FlightsCurrentContainer.js